exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divisor[data-v-20b0c948]{width:5px;border-radius:5px;background-color:var(--gray-400)}.content[data-v-20b0c948]{line-height:normal}div[data-v-20b0c948]{color:var(--gray-400)}", ""]);

// exports
